import React, { useState, useEffect } from 'react';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Sprawdź czy użytkownik już wyraził zgodę
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShowBanner(false);
    
    // Włącz Google Analytics po wyrażeniu zgody
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    }
  };

  const declineCookies = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setShowBanner(false);
    
    // Wyłącz Google Analytics po odmowie zgody
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="cookie-banner">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-8">
            <p>
              Ta strona używa plików cookie, aby zapewnić najlepsze doświadczenia na naszej stronie. 
              Kontynuując korzystanie ze strony, wyrażasz zgodę na używanie plików cookie zgodnie z naszą&nbsp;
              <a href="/polityka-prywatnosci/">
                Polityką Prywatności
              </a>.
            </p>
          </div>
          <div className="col-lg-4 text-lg-end mt-3 mt-lg-0">
            <button
              onClick={declineCookies}
              className="btn-decline"
            >
              Odrzuć
            </button>
            <button
              onClick={acceptCookies}
              className="btn-accept"
            >
              Akceptuję
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
